import { Gift, Ticket, Truck, Check } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { cn } from "@/lib/utils";
import { rewardSummary, fmtPts } from "@/lib/loyalty";

function Option({ on, disabled, onClick, icon: Icon, img, title, points, testId, color }) {
  return (
    <button type="button" disabled={disabled} onClick={onClick} data-testid={testId}
      className={cn("flex items-center gap-3 rounded-lg border p-2 text-left text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-40",
        on ? "border-amber-500 bg-amber-500/15" : "hover:bg-amber-500/10")}
      style={on && color ? { borderColor: color, background: `${color}14` } : undefined}>
      {img ? <img src={imgUrl(img)} alt="" className="h-10 w-10 shrink-0 rounded-md object-cover" />
        : <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-amber-500/15 text-amber-600"><Icon className="h-5 w-5" /></span>}
      <span className="min-w-0 flex-1"><span className="block truncate font-medium">{title}</span><span className="text-xs opacity-70">{fmtPts(points)}</span></span>
      {on && <Check className="h-4 w-4 shrink-0" />}
    </button>
  );
}

export function RewardPicker({ wallet, sel, setSel, freeDel = false, setFreeDel, allowFreeDelivery = false, color }) {
  if (!wallet?.enabled || wallet.mode !== "points") return null;
  const used = rewardSummary(wallet, sel, freeDel).points;
  const left = wallet.balance - used;
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const fd = allowFreeDelivery && wallet.free_delivery?.enabled ? wallet.free_delivery : null;
  return (
    <div className="space-y-2 rounded-xl border border-amber-500/40 bg-amber-500/5 p-3" data-testid="reward-picker">
      <p className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="flex items-center gap-2 font-semibold"><Gift className="h-4 w-4 text-amber-500" />Trocar pontos</span>
        <span className="text-xs">Saldo: <b data-testid="reward-balance">{fmtPts(wallet.balance)}</b>{used > 0 && <> · usando <b data-testid="reward-used">{fmtPts(used)}</b></>}</span>
      </p>
      {!wallet.rewards.length && !fd ? <p className="text-xs opacity-70" data-testid="reward-empty">Nenhuma recompensa disponível ainda.</p> : (
        <div className="grid gap-2 sm:grid-cols-2">
          {wallet.rewards.map((r) => {
            const on = sel.includes(r.id);
            return <Option key={r.id} on={on} disabled={!on && r.points > left} onClick={() => toggle(r.id)} icon={Ticket} img={r.image_url}
              title={r.type === "product" ? `${r.name} grátis` : r.name} points={r.points} testId={`reward-option-${r.id}`} color={color} />;
          })}
          {fd && <Option on={freeDel} disabled={!freeDel && fd.points > left} onClick={() => setFreeDel(!freeDel)} icon={Truck} title="Entrega grátis"
            points={fd.points} testId="reward-option-free-delivery" color={color} />}
        </div>
      )}
    </div>
  );
}
